/* React base component */
import { Component } from "react"

/* Component Timing */
class Timing extends Component {

    constructor(props) {
        super(props)
        /* State */
        this.state = { seconds: this.props.seconds || 0 }
    }

    /* Interval handle */
    timer = null

    componentDidMount = () => {
        this.start()
    }

    componentDidUpdate = (prev) => {
        if (prev.seconds !== this.props.seconds) {
            this.setState({ seconds: this.props.seconds || 0 }, this.start)
        }
    }

    componentWillUnmount = () => {
        this.stop()
    }

    start = () => {
        this.stop()
        this.timer = setInterval(this.tick, 1000)
    }

    stop = () => {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
    }

    tick = () => {
        this.setState((state) => {
            if (state.seconds <= 1) {
                this.stop()
                if (this.props.onEnd) {
                    this.props.onEnd()
                }
                return { seconds: 0 }
            }
            return { seconds: state.seconds - 1 }
        })
    }

    render = () => {
        return this.props.children ? this.props.children(this.state.seconds) : <span>{this.state.seconds}</span>
    }
}

/* Export */
export default Timing
